import React from 'react';
import { Link } from 'react-router-dom';

const FOOTER_LINKS = [
  { path: '/awards', label: 'Travel Awards' },
  { path: '/twblawards', label: 'TWBL Awards' },
  { path: '/winners/2021', label: 'Winners' },
  { path: '/methodology', label: 'Methodology' },
];

export default function Footer() {
  return (
    <footer
      className="py-12 px-4 sm:px-6 lg:px-8 border-t border-white/5 bg-[#0A0A0A]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Brand */}
          <Link
            to="/"
            className="leading-none"
            data-testid="footer-brand"
          >
            <span className="font-['Playfair_Display'] text-lg font-semibold text-white block">
              Travel-Awards
            </span>
            <span className="text-[#D4AF37] text-xs block mt-0.5 tracking-widest uppercase">
              .org
            </span>
          </Link>

          {/* Footer menu */}
          <nav
            className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2"
            data-testid="footer-menu"
          >
            {FOOTER_LINKS.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className="text-sm text-white/60 hover:text-[#D4AF37] transition-colors uppercase tracking-[0.2em]"
                data-testid={`footer-link-${l.path.replace(/\//g, '-')}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-white/40 text-xs text-center md:text-right">
            © {new Date().getFullYear()} Travel-Awards.org
            <span className="block md:inline md:ml-1">
              Celebrating excellence in global hospitality.
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
